import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/solutions/explode`;

export interface SplitFileAlongSolutionsCommandPayload {
  fileId: string;
}

export const splitFileAlongSolutionsRequest = ({
  fileId,
}: SplitFileAlongSolutionsCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.PUT, json: {} },
});

async function splitFileAlongSolutionsCommand(
  payload: SplitFileAlongSolutionsCommandPayload,
): Promise<BackResponse<string[]> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<string[]>>(
      splitFileAlongSolutionsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default splitFileAlongSolutionsCommand;
